module.exports = __webpack_public_path__ + "static/media/logo_login.a5d0d641.svg";